<template>
  <div class="config_main_manage_background">
    <!-- 设置页面的内容区域 -->
    <div class="config_main_manage_page_wraper">
      <div class="config_main_manage_page_content">
        <!-- 设置页面收藏区域的内容区域样式   以上部分都是公共样式 -->

        <config-title-hang>
          <span slot="config_title_hang_ele2" v-if="query.kind === 1">当前网络信息</span>
          <span slot="config_title_hang_ele2" v-else>待更新的网络</span>
          <img slot="config_title_hang_ele5_img" src="~assets/img/config/shuaxin_bai.png" @click="updataBtnHandle(2)"
            alt />
          <span slot="config_title_hang_ele5" @click="updataBtnHandle(2)">随机获取</span>
        </config-title-hang>
        <div v-if="query.isDefault == false">
          <config-hang inputID="networkName">
            <span slot="config_hang_ele2">网络名称</span>
            <!-- img和input 配套使用 点击可以触发input的聚焦事件  v-model实际上是直接绑定的仓库数据信息 -->
            <img slot="config_hang_xiugai" src="~assets/img/config/xiugai.png" alt />
            <input type="text" slot="config_hang_input_right" id="networkName" placeholder="最多16英文字符"
              v-model="query.networkName" />
          </config-hang>

          <config-hang inputID="meshLocalPrefix">
            <span slot="config_hang_ele2">IP6本地前缀</span>
            <!-- img和input 配套使用 点击可以触发input的聚焦事件  v-model实际上是直接绑定的仓库数据信息 -->
            <img slot="config_hang_xiugai" src="~assets/img/config/xiugai.png" alt />
            <input type="text" slot="config_hang_input_right" id="meshLocalPrefix" placeholder="IP6本地前缀格式"
              v-model="query.meshLocalPrefix" />
          </config-hang>

          <config-hang inputID="channel">
            <span slot="config_hang_ele2">信道</span>
            <!-- img和input 配套使用 点击可以触发input的聚焦事件  v-model实际上是直接绑定的仓库数据信息 -->
            <img slot="config_hang_xiugai" src="~assets/img/config/xiugai.png" alt />
            <input type="number" slot="config_hang_input_right" id="channel" placeholder="11-26"
              v-model="query.channel" />
          </config-hang>
          <config-hang inputID="panId">
            <span slot="config_hang_ele2">PAN ID</span>
            <!-- img和input 配套使用 点击可以触发input的聚焦事件  v-model实际上是直接绑定的仓库数据信息 -->
            <img slot="config_hang_xiugai" src="~assets/img/config/xiugai.png" alt />
            <input type="text" slot="config_hang_input_right" id="panId" placeholder="4个16进制字符" v-model="hexPanId" />
          </config-hang>

          <config-hang inputID="extendedPanId">
            <span slot="config_hang_ele2">XPAN ID</span>
            <!-- img和input 配套使用 点击可以触发input的聚焦事件  v-model实际上是直接绑定的仓库数据信息 -->
            <img slot="config_hang_xiugai" src="~assets/img/config/xiugai.png" alt />
            <input type="text" slot="config_hang_input_right" id="extendedPanId" placeholder="16个16进制字符"
              v-model="query.extendedPanId" />
          </config-hang>

          <config-hang inputID="networkKey">
            <span slot="config_hang_ele2">网络密钥</span>
            <!-- img和input 配套使用 点击可以触发input的聚焦事件  v-model实际上是直接绑定的仓库数据信息 -->
            <img slot="config_hang_xiugai" src="~assets/img/config/xiugai.png" alt />
            <input type="text" slot="config_hang_input_right" id="networkKey" placeholder="32个16进制字符"
              v-model="query.networkKey" />
          </config-hang>
        </div>
        <div v-if="query.isDefault == true" class="xiaotishi_style">
          小提示:当前网络未设置,安全性较低,仅限于调试用途,建议完成调试后,点击随机获取,并更新当前网络信息.
        </div>
        <div v-if="query.isDefault == true" class="xiaotishi_style">
          完成调试:是指,所有设备均已添加到系统,并且在设备上线管理页面显示,所有设备在线,不存在新发现设备.
        </div>
        <div v-if="query.isDefault == false" class="xiaotishi_style">
          小提示:部分参数长度,类型限制较严格,建议使用 随机获取 的参数,进行更新.
          <br />
          注意:该操作将会更新网络内的所有设备,等待时间较长,非专业人士不建议进行网络信息的更新.
        </div>
        <div v-if="query.isDefault == false" class="xiaotishi_style">
          如需更新操作:请确保设备上线管理页面显示,所有设备在线,不存在新发现设备,不存在网络密钥重复的主机,更新过程中切勿断电.
        </div>

        <div v-if="query.isDefault == false" class="public_config_que_ren_btn" @click="requestBtnHandle">
          确认更新(时间较长,谨慎操作!)
        </div>



        <!-- //代号20220319-1 -->
        <!-- <div v-if="$route.query.type === 'change' || $route.query.type === 'changeOffLine'"
          class="public_config_que_ren_btn" @click="replaceBtnHandle">替换设备(不建议进行此操作)</div> -->
      </div>
    </div>
  </div>
</template>
<script>
// import topNav from "components/common/topnav/topnav";
// import topNavItem from "components/common/topnav/topnavitem";
import configTitleHang from "components/common/config/config-title-hang";

import configHang from "components/common/config/config-hang";

export default {
  data() {
    return {
      oneHostDeviceListData: {
        ////服务器请求到的主机下面的设备列表
        offLineList: [],
        onLineList: []
      },
      oneHostData: {
        ////一个主机的信息
      },
      //代号20220319-1
      query: this.$route.query,
    };
  },
  computed: {
    // 显示 16 进制的计算属性
    hexPanId: {
      get() {
        console.log("Getting hexPanId:", this.query.panId);
        // 转换为小写十六进制
        return this.query.panId.toString(16);
      },
      set(value) {
        console.log("Setting hexPanId:", value);
        // 直接将输入解析为十六进制
        const decimalValue = parseInt(value, 16);

        if (!isNaN(decimalValue)) {
          this.query.panId = decimalValue;
        } else if (value === "") {
          this.query.panId = 0;
        }
      }
    }

  },
  components: {
    // topNav,
    // topNavItem,
    configHang,
    configTitleHang
  },
  methods: {
    updataBtnHandle(kind) {
      //获取当前网关的 thread 网络信息
      this.$request({
        method: "post",
        url: "/gateway/getThreadNetworkInfo",
        data: {
          token: this.$store.state.token,
          gatewayId: this.oneHostData.gatewayId, //  value.gatewayId
          kind: kind //1 获取当前活跃的网络信息 2 获取随机新的网络信息
        }
      })
        .then(res => {
          if (res.data.code != 0) {
            this.$showTipsToast(3, res.data.message);
            ////说明信息填写错误,控制失败了，
            return;
          } else {
            ////、控制成功了
            let data = res.data.data; ////拿到服务器返回的数据结果
            console.log("获取到网络信息:", data);
            this.query = data;
          }
        })
        .catch(error => {
          console.log(error);
        });

    },
    requestBtnHandle() {
      // 更新当前网关的 thread 网络信息
      this.$asyncMessageKeyRequest({
        url: "/gateway/updateThreadNetworkInfo",
        data: {
          token: this.$store.state.token,
          gatewayId: this.oneHostData.gatewayId,

          isRandom: false,
          pendingTimestamp: 0,
          delay: 0,
          // 虽然实际更新不需要activeTimestamp,但是更新需要把这些数据写入数据库,因此需要传入
          activeTimestamp: this.query.activeTimestamp,
          pskc: this.query.pskc,
          channel: this.query.channel,
          extendedPanId: this.query.extendedPanId,
          meshLocalPrefix: this.query.meshLocalPrefix,
          networkKey: this.query.networkKey,
          networkName: this.query.networkName,
          panId: this.query.panId,
        },
        customLoadingStartFn: null,
        customLoadingStopFn: null
      }, this.redisMessageIdCallback)
    },
    redisMessageIdCallback(res, stopUpdateTimerFn) {
      const { data } = res;
      console.log("返回数据:", data);
      if (data.mapData != null) {
        // 如果更新完成，停止定时器
        if (data.mapData.code == 5) {
          console.log("当前完成时间:", new Date());
          stopUpdateTimerFn(); // 停止循环定时器
          this.$showTipsToast(3, "当前网络更新完成~"); ////提示框
          // this.$router.go(-1);
          return;
        }
        else {
          console.log("当前完成时间:", new Date());
          stopUpdateTimerFn(); // 停止循环定时器
          console.log("请求更新出现错误,错误码:", data.mapData.code);
          this.$showTips1Toast(3, "当前网络更新失败~"); ////提示框
          // 重新获取当前最新活跃的网络信息,并更新到数据库中.
          this.updataBtnHandle(1);
        }
      }

    },
  },

  mounted() {
    console.log("mounted阶段");
    // console.log(this.$route.query)
  },
  created() {
    console.log("created阶段");
    console.log(this.$route.query)
    this.query = this.$route.query;
    this.oneHostData = this.$store.state.configinfo.oneHostData; ///拿到仓库当前主机的信息
    this.oneHostDeviceListData = this.$store.state.configinfo.oneHostDeviceListData; ///拿到仓库当前主机下的设备列表
    console.log(this.query);
    console.log(this.oneHostData);
    console.log(this.oneHostDeviceListData);
    //  this.$forceUpdate()  ////强制更新视图
  }
};
</script>

<style>
div .add_device_input {
  /* 聚焦时不切换输入法 */
  ime-mode: auto;
}
</style>